module.exports = __webpack_public_path__ + "img/qrcode.a07c780b.png";